import { getDomain } from 'tldts';
/** The host a URL belongs to, or null when it has none we classify or show.
 *
 *  THE domain normaliser for activity (ClickUp 86d4a9r1f). Ingest stores its
 *  result in `agent_activity_events.domain`, the Activity Log renders it, and
 *  classification keys on it. Do not write a second one.
 *
 *  Rule: http(s) only, `URL.hostname` (lowercased, IDN → punycode by the
 *  parser), one leading `www.` stripped, other subdomains kept. Moved here from
 *  `apps/dashboard/.../activityLogCells.ts`, which mirrored doer-apps
 *  `extension/lib.js` `domainFromUrl`. */
export function hostFromUrl(url) {
    if (!url)
        return null;
    try {
        const u = new URL(url);
        if (u.protocol !== 'http:' && u.protocol !== 'https:')
            return null;
        return u.hostname.replace(/^www\./i, '') || null;
    }
    catch {
        return null;
    }
}
/** The same rule for a bare host that arrives without a URL (e.g. an ActivTrak
 *  website name or a hand-typed key). It goes through `hostFromUrl` so the key
 *  is exactly what ingest stores for that site: IDN becomes punycode, a port or
 *  path is dropped, a pasted URL is reduced to its host, and anything with no
 *  http(s) host is null. Trimmed first, because `new URL('https:// x')` fails. */
export function normaliseHost(host) {
    const h = host?.trim();
    if (!h)
        return null;
    return hostFromUrl(/^[a-z][a-z0-9+.-]*:\/\//i.test(h) ? h : `https://${h}`);
}
/** The registrable domain per the Public Suffix List, private section ON, so a
 *  shared hosting suffix (`vercel.app`, `github.io`) is a boundary and never a
 *  parent. Null for IPs, `localhost` and single-label hosts. */
export function registrableDomain(host) {
    return getDomain(host, { allowPrivateDomains: true }) ?? null;
}
/** Classification lookup order for a host: exact, then registrable parent. */
export function domainLookupKeys(host) {
    const parent = registrableDomain(host);
    return parent && parent !== host ? [host, parent] : [host];
}
//# sourceMappingURL=activity-domain.js.map